import {Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Project} from '../../../api';
import {ProjectKindPipe} from '../../../pipes/project-kind.pipe';
import {ProjectStatePipe} from '../../../pipes/project-state.pipe';
import { DatePipe } from "@angular/common";
import {MapComponent, PlacePoint} from '../map/map.component';

@Component({
    selector: 'app-dashboard-project-information',
    templateUrl: './dashboard-project-information.component.html',
    styleUrls: ['./dashboard-project-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ProjectStatePipe, ProjectKindPipe, DatePipe, MapComponent]
})
export class DashboardProjectInformationComponent implements OnInit, OnDestroy {

  @Input() project!: Project;

  placePoints: PlacePoint[] = [];
  mapReady = false;

  /** True while the card is tall enough to show the map */
  showMap = false;

  /** Below this card height the map is hidden to avoid a cramped layout */
  private readonly MAP_HEIGHT_THRESHOLD = 290;
  private resizeObserver?: ResizeObserver;

  constructor(private el: ElementRef, private zone: NgZone) {}

  ngOnInit(): void {
    if (this.project.latitude != null && this.project.longitude != null) {
      this.placePoints = [{
        name: this.project.name ?? 'Projekt',
        latitude: this.project.latitude,
        longitude: this.project.longitude,
        description: `${this.project.street ?? ''} ${this.project.houseNumber ?? ''}, ${this.project.zipCode ?? ''} ${this.project.buildingPlace ?? ''}`
      }];
      this.mapReady = true;
    }

    this.resizeObserver = new ResizeObserver(entries => {
      const height = entries[0]?.contentRect.height ?? 0;
      const shouldShow = height >= this.MAP_HEIGHT_THRESHOLD;
      if (shouldShow !== this.showMap) {
        this.zone.run(() => this.showMap = shouldShow);
      }
    });
    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
